const COLORS = ['#2563eb', '#16a34a', '#eab308', '#f97316', '#ec4899', '#06b6d4', '#ffffff'];

function randomBetween(min, max) {
	return min + Math.random() * (max - min);
}

function createParticle(originX, originY, options = {}) {
	const angle = options.angle != null ? options.angle : randomBetween(-Math.PI, 0);
	const speed = options.speed != null ? options.speed : randomBetween(6, 14);
	return {
		x: originX,
		y: originY,
		vx: Math.cos(angle) * speed,
		vy: Math.sin(angle) * speed - randomBetween(2, 6),
		w: randomBetween(6, 10),
		h: randomBetween(4, 8),
		rotation: randomBetween(0, Math.PI * 2),
		spin: randomBetween(-0.2, 0.2),
		color: COLORS[Math.floor(Math.random() * COLORS.length)],
		gravity: 0.22,
		friction: 0.98,
		alpha: 1,
		decay: randomBetween(0.008, 0.014),
		shape: Math.random() > 0.35 ? 'rect' : 'circle'
	};
}

function spawnBurst(particles, x, y, count, spreadRadians) {
	for (let i = 0; i < count; i += 1) {
		const angle = randomBetween(-spreadRadians / 2, spreadRadians / 2) - Math.PI / 2;
		particles.push(
			createParticle(x, y, {
				angle,
				speed: randomBetween(8, 16)
			})
		);
	}
}

function resizeCanvas(canvas) {
	const dpr = window.devicePixelRatio || 1;
	const width = window.innerWidth;
	const height = window.innerHeight;
	canvas.width = width * dpr;
	canvas.height = height * dpr;
	canvas.style.width = `${width}px`;
	canvas.style.height = `${height}px`;
	const ctx = canvas.getContext('2d');
	ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	return { width, height, ctx };
}

/**
 * Full-screen confetti + firework-style bursts (canvas, no dependencies).
 */
export function celebrateChallengeComplete() {
	if (typeof window === 'undefined') return;
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	const canvas = document.createElement('canvas');
	canvas.setAttribute('aria-hidden', 'true');
	canvas.style.cssText =
		'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999';
	document.body.appendChild(canvas);

	let { width, height, ctx } = resizeCanvas(canvas);
	const particles = [];

	spawnBurst(particles, width * 0.2, height * 0.85, 50, Math.PI * 0.9);
	spawnBurst(particles, width * 0.8, height * 0.85, 50, Math.PI * 0.9);
	spawnBurst(particles, width * 0.5, height * 0.55, 70, Math.PI * 1.4);

	const fireworkTimers = [0, 280, 520].map((delay) =>
		window.setTimeout(() => {
			const fx = randomBetween(width * 0.25, width * 0.75);
			const fy = randomBetween(height * 0.2, height * 0.45);
			spawnBurst(particles, fx, fy, 40, Math.PI * 2);
		}, delay)
	);

	const onResize = () => {
		({ width, height, ctx } = resizeCanvas(canvas));
	};
	window.addEventListener('resize', onResize);

	const start = performance.now();
	const durationMs = 2800;

	function frame(now) {
		const elapsed = now - start;
		ctx.clearRect(0, 0, width, height);

		let alive = 0;
		particles.forEach((p) => {
			p.vx *= p.friction;
			p.vy += p.gravity;
			p.x += p.vx;
			p.y += p.vy;
			p.rotation += p.spin;
			p.alpha -= p.decay;

			if (p.alpha <= 0) return;
			alive += 1;

			ctx.save();
			ctx.globalAlpha = Math.max(0, p.alpha);
			ctx.fillStyle = p.color;
			ctx.translate(p.x, p.y);
			ctx.rotate(p.rotation);

			if (p.shape === 'circle') {
				ctx.beginPath();
				ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
				ctx.fill();
			} else {
				ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
			}
			ctx.restore();
		});

		if (elapsed < durationMs && alive > 0) {
			requestAnimationFrame(frame);
		} else {
			window.removeEventListener('resize', onResize);
			fireworkTimers.forEach((id) => window.clearTimeout(id));
			canvas.remove();
		}
	}

	requestAnimationFrame(frame);
}
